import api from '@plugins/api';

export function getPromise(url) {
  return new Promise((resolve, reject) => {
    api
      .get(url)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function patchPromise(url, data) {
  return new Promise((resolve, reject) => {
    api
      .patch(url, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function postPromise(url, data) {
  return new Promise((resolve, reject) => {
    api
      .post(url, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function putPromise(url, data) {
  return new Promise((resolve, reject) => {
    api
      .put(url, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function deletePromise(url, data = {}) {
  return new Promise((resolve, reject) => {
    api
      .delete(url, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export default { getPromise, postPromise, patchPromise, deletePromise };
